import React from 'react';
import { get_dynamic_styles } from '../../constant/DynamicStyles';
import { useSelector } from 'react-redux';
import { userSelector } from '../../store/feature/user/userSlice';

const UserFirstName = ({ data, styles, user }) => {
  const { user_details } = useSelector(userSelector);
  return (
    <div style={get_dynamic_styles(styles?.main_styles)}>
      <h2 style={get_dynamic_styles(styles?.text_styles)}>
        {user?.first_name || user_details?.first_name}
      </h2>
    </div>
  );
};

export default UserFirstName;
